import Index from '@/pages/index.page';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/workspaces/')({
  component: Index,
});
